import { combineReducers } from "redux";
import VideoCallReducer from "./videoCallReducer";
import { chatReducer } from "./reducers/chatReducer";
import { commonReducer } from "./reducers/commonReducer";
import cartReducer from "./reducers/cartReducer";
import { ordersReducer } from "./reducers/ordersReducer";
import { notificationReducer } from "./reducers/notificationReducer";
import { authReducer } from "./reducers/authReducer";
import { membershipReducer } from "./reducers/membershipReducer";
import { appointmentReducer } from "./reducers/appointmentReducer";

export default combineReducers({
  auth: authReducer,
  videoCall: VideoCallReducer,
  chatCount: chatReducer,
  cart: cartReducer,
  common: commonReducer,
  orders: ordersReducer,
  notificationCount: notificationReducer,
  memberships: membershipReducer,
  appt: appointmentReducer,
});
